import moment from 'moment'
import Vue from 'vue'
import store from '@/store/index'

const state = {
  incubatorBeeList: [],
  incubatorBeeFilter: [],
  chats: [],
  notifications: [],
  unreadNotifications: 0,
  unreadChat: 0,
  showChatBadge: false,
  showNotificationBadge: false,
  speakOut: false,
  stompClient: null,
  WSConnected: false
}

const mutations = {
  CHAT_PUSH(state, obj) {
    state.chats.push(obj)
    if (obj.from === 'Buzz') {
      state.unreadChat = state.unreadChat + 1
      state.showChatBadge = true

      if (state.speakOut) {
        let speech = new SpeechSynthesisUtterance()

        // Set the text and voice attributes.
        speech.text = obj.message
        speech.volume = 1
        speech.rate = 1
        speech.pitch = 1

        window.speechSynthesis.speak(speech)
        state.speakOut = !state.speakOut
      }
    }
  },

  TOOGLE_VOICE(state) {
    state.speakOut = !state.speakOut
  },

  NOTIFICATION_PUSH(state, obj) {
    obj.type = obj.type.toString().toLowerCase()
    if (obj.type === 'warning') {
      obj.icon = 'warning'
      obj.color = '#f48a06'
    } else if (obj.type === 'info') {
      obj.icon = 'info'
      obj.color = '#187fe7'
    } else if (obj.type === 'error') {
      obj.icon = 'error'
      obj.color = '#b82e24'
    } else if (obj.type === 'success') {
      obj.icon = 'check_circle'
      obj.color = '#42a85f'
    }
    state.notifications.unshift(obj)
    state.unreadNotifications = state.unreadNotifications + 1
    state.showNotificationBadge = true
    if (!obj.hideNotification) {
      Vue.notify({
        /**/
        group: 'userActivity',
        title: obj.message,
        text: obj.description,
        type: obj.type
      })
    }
  },
  CLEAR_NOTIFICATION_ALL(state) {
    state.notifications = []
    state.unreadNotifications = 0
    state.showNotificationBadge = false
  },
  READ_CHAT(state) {
    state.unreadChat = 0
    state.showChatBadge = false
  },
  READ_NOTIFICATION(state) {
    state.unreadNotifications = 0
    state.showNotificationBadge = false
    Vue.notify({
      group: 'userActivity',
      clean: true
    })
  },
  CLEAR_NOTIFICATION(state, index) {
    state.notifications.splice(index, 1)
    state.unreadNotifications = state.unreadNotifications - 1
  },
  SET_WS_CONNECTED(state, status) {
    state.WSConnected = status
  }
}

const actions = {
  triggerVueNotification(obj) {
    Vue.notify({
      group: 'userActivity',
      text: obj.message,
      type: obj.type
    })
  },

  async subscribeSockets({ dispatch, commit }) {
    if (!store.getters.getUser.session) {
      await dispatch('getUserPrincipal')
    }

    let sessionId = store.getters.getUser.session
    let ws = new SockJS('/beekeeper-sockets', [], {
      sessionId: () => {
        return sessionId
      }
    })
    let userName = store.getters.getUser.name
    // this.stompClient = Stomp.over(ws)
    // this.stompClient.connect({}, () => {
    //   let url = this.stompClient.ws._transport.url
    //   console.log(url)
    //   console.log(sessionId)
    //   this.stompClient.subscribe('/user/queue/chats', message => {
    //     if (message.body) {
    //       let chatMessage = JSON.parse(message.body)
    //       let obj = {}
    //       obj.message = chatMessage.response
    //       obj.to = userName
    //       obj.from = 'Buzz'
    //       obj.timestamp = moment(chatMessage.createdAt).format(
    //         'DD MMM YYYY hh:mm:ss a'
    //       )
    //
    //       commit('CHAT_PUSH', obj)
    //     }
    //   })
    //
    //   this.stompClient.subscribe('/user/queue/notifications', message => {
    //     if (message.body) {
    //       let notifMessage = JSON.parse(message.body)
    //       let obj = {}
    //       obj.message = notifMessage.notificationMessage
    //       obj.description =
    //         notifMessage.notificationDescription != null
    //           ? notifMessage.notificationDescription.slice(0, 150) + '...'
    //           : ''
    //       obj.type = notifMessage.notificationType
    //       obj.timestamp = moment
    //         .unix(notifMessage.createdAt)
    //         .format('DD MMM YYYY hh:mm:ss a')
    //       obj.actions = notifMessage.actions
    //       commit('NOTIFICATION_PUSH', obj)
    //     }
    //   })
    //
    //   this.stompClient.subscribe('/user/queue/dataRefresh', message => {
    //     if (message.body) {
    //       let dataRefresh = JSON.parse(message.body)
    //       if (dataRefresh.entityName === 'Execution') {
    //         store.dispatch('fetchExecutions')
    //       } else if (dataRefresh.entityName === 'AutomationRequest') {
    //         store.dispatch('fetchSelfServiceMetrics')
    //         store.dispatch('fetchAutomationRequests', dataRefresh.entityId)
    //       } else if (dataRefresh.entityName === 'Task') {
    //         store.dispatch('fetchClaimedTasks', 'page=0&size=1')
    //       }
    //     }
    //   })
    // })
    // commit('SET_WS_CONNECTED', true)
  },

  clearAllNotification({ commit }) {
    commit('CLEAR_NOTIFICATION_ALL')
  },

  readNotification({ commit }) {
    commit('READ_NOTIFICATION')
  },

  readChat({ commit }) {
    commit('READ_CHAT')
  },

  toggleVoice({ commit }) {
    commit('TOOGLE_VOICE')
  },

  clearNotification({ commit }, index) {
    commit('CLEAR_NOTIFICATION', index)
  },

  unsubscribeChat({ commit }) {
    if (this.stompClient !== null) {
      this.stompClient.disconnect()
      commit('SET_WS_CONNECTED', false)
    }
  },

  sendChat({ commit }, message) {
    let objs = {}
    objs.message = message
    objs.from = store.getters.getUser.name
    objs.to = 'Buzz'
    objs.timestamp = moment().format('DD MMM YYYY hh:mm:ss a')
    commit('CHAT_PUSH', objs)

    // Updated to websockets
    this.stompClient.send(
      '/socks/api/buzz/v1/chat',
      {},
      JSON.stringify({
        request: message,
        session: store.getters.getUser.session
      })
    )
  },

  directMessage({ commit }, message) {
    let objs = {}
    objs.message = message
    objs.from = 'Buzz'
    objs.to = store.getters.getUser.name
    objs.timestamp = moment().format('DD MMM YYYY hh:mm:ss a')
    commit('CHAT_PUSH', objs)
  },

  directNotification({ commit }, obj) {
    commit('NOTIFICATION_PUSH', obj)
  }
}

export default {
  state,
  mutations,
  actions
}
